var Marionette = require('backbone.marionette');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Dicts = require('../../data/dicts');
var CommonUtils = require('../../utils/common-utils.js');

var utils = new CommonUtils();

var RepresentativeRowView = Marionette.View.extend({
    tagName: 'tr',
    className: 'representative-row clickable',
    template: require('../../templates/contacts/representative-row.html'),

    ui: {
        td: 'td'
    },

    events: {
        'click #representative-delete': 'removeRepresentative',
        'click #representative-edit': 'editRepresentative',
        'click @ui.td': 'onRowSelected'
    },

    representativeHovered: false,

    templateContext: function () {
        var that = this;
        var contactorObj = this.model.get('personToContact') || {};
        var contactorDistplay = (contactorObj.prefix || "") + " " + (contactorObj.firstName || "") + " " + (contactorObj.lastName || "");
        if (this.model.get('personToContactType')){
            contactorDistplay = this.model.get('personToContactType') + ": " + contactorDistplay;
        }
        return {
            canEdit: that.getOption('canEdit'),
            contactor: contactorDistplay,
            link: function () {
                var link = "";
                var entityId = that.model.get('entityId');
                var name = that.model.get('name');
                if (!_.isEmpty(entityId) && !_.isEmpty(name)) {
                    var type = that.model.get('type');
                    if (type === "PERSON")
                        link = '<a href="/#person/' + entityId + '" target="_blank">' + name + '</a>';
                    else if (type === "ORGANIZATION")
                        link = '<a href="/#organization/' + entityId + '" target="_blank">' + name + '</a>';
                }
                return link;
            }
        }
    },

    initialize: function (options) {
        //_.bindAll(this, 'removeAddress', 'editAddress', 'onRowSelected');
        this.className = this.model.get('uuid');
    },

    removeRepresentative: function (event) {
        this.triggerMethod('delete:model', this.model);
    },

    editRepresentative: function (event) {
        this.triggerMethod('update:model', this.model);
    },

    onRowSelected: function () {
        var that = this;
        this.representativeHovered = !this.representativeHovered;
        this.triggerMethod('representative:hover', {hovered: this.representativeHovered, uuid: that.model.get('uuid')});
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(5), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var RepresentativeTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: RepresentativeRowView,
    emptyView: EmptyView,

    childViewEvents: {
        'update:model': 'updateModel',
        'update:model:wo:confirm': 'updateModelWoConfirm',
        'delete:model': 'deleteModel',
        'representative:hover': 'representativeHover'
    },

    childViewOptions: function () {
        var that = this;
        return {
            canEdit: that.getOption('canEdit')
        }
    },

    initialize: function (options) {
        //_.bindAll(this, 'updateModel', 'deleteModel', 'updateModelWoConfirm', 'addressHover');
        this.collection = options.collection;
    },

    updateModel: function (model) {
        var callback = function () {
            this.triggerMethod('on:representative:action', {mode: 'edit', data: model});
        };
        this.triggerMethod('on:action', {
            callback: callback,
            mode: 'edit'
        });
    },

    updateModelWoConfirm: function (model) {
        this.triggerMethod('update:model:wo:confirm', model);
    },

    deleteModel: function (model) {
        var callback = function () {
            this.triggerMethod('on:representative:action', {mode: 'delete', data: model});
        };
        this.triggerMethod('on:action', {
            callback: callback,
            mode: 'delete'
        });
    },

    representativeHover: function (hovered) {
        this.triggerMethod('representative:hover', hovered);
    }
});

var RepresentativesTableView = Marionette.View.extend({
    tagName: 'div',
    className: 'representatives-table',
    template: require('../../templates/contacts/representatives-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        confirmationModal: '#yes-no-confirmation-modal'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',
        'update:model:wo:confirm': 'updateModelWoConfirm',
        'on:action': 'onAction',
        'representative:hover': 'representativeHover'
    },

    ui: {
        addRepresentative: '#add-representative'
    },

    events: {
        'click @ui.addRepresentative': 'addNewRepresentative'
    },

    callback: undefined,

    templateContext: function () {
        return {
            canEdit: this.canEdit
        }
    },

    onRender: function () {
        this.showChildView('body', new RepresentativeTableBody({
            collection: this.collection,
            canEdit: this.canEdit
        }));
    },

    initialize: function (options) {
        //_.bindAll(this, 'saveConfirmed', 'onAction', 'addNewAddress', 'updateModelWoConfirm', 'addressHover');
        this.collection = options.collection;
        this.canEdit = options.canEdit;
    },

    renderConfirmationModal: function(mode) {
        this.confirmationalModal = new YesNoConfirmationModal({message: 'You are going to ' + mode + ' representative. Are you sure?'});
        this.showChildView('confirmationModal', this.confirmationalModal);
        this.confirmationalModal.show();
    },

    onAction: function (data) {
        this.callback = data.callback;
        if (typeof this.callback !== "function")
            return;
        this.renderConfirmationModal(data.mode);
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.confirmationalModal.hide();
        }
    },

    addNewRepresentative: function () {
        this.triggerMethod('on:representative:action', {mode: 'add', data: ''});
    },

    updateModelWoConfirm: function (model) {
        this.triggerMethod('on:representative:action', {mode: 'save', data: model});
    },

    representativeHover: function (hovered) {
        this.triggerMethod('representative:hover', hovered);
    }
});

module.exports = RepresentativesTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/contacts/representatives-table-view.js
// module id = 261
// module chunks = 0